import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles(() => ({
    main: {
        height: '100%',
    },
    searchForm: {
        marginTop: 0,
        top: 56,
        position: 'absolute',
        left: 0,
        right: 0,
        padding: '18px 24px 0 ',
        '@media (max-width: 1024px)': {
            position: 'fixed',
        },
    },
    searchIcon: {
        position: 'absolute',
        left: 10,
        top: 2,
        color: 'white',
    },

    input: {
        padding: '10px 0 10px 30px',
        background: 'transparent',
        border: 'none',
        borderBottom: '1px solid #4a6c72 ',
        color: 'white',
        fontSize: 14,
        position: 'relative',
    },
    filter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        // marginBottom: 10
    },
    chipOutline: {
        border: `1px solid ${themes.palette.grey['300']}`,
    },
    chipLabel: {
        padding: '0 8px',
        color: 'white',
        fontFamily: 'PoppinsRegular',
        fontSize: 12,
        fontWeight: 600,
    },
    chipIcon: {
        color: 'white',
    },
}));
